import React, { useState, useEffect, createContext, useContext } from "react";
import Nav from "./Components/home page/nav";
import Hero from "./Components/home page/hero";
import Projects from "./Components/home page/Projects";
import About from "./Components/home page/About";
import Parteners from "./Components/home page/Parteners";
import Testimonials from "./Components/home page/Testimonials";
import Footer from "./Components/home page/Footer";
import Footer1 from "./Components/home page/Footer1";
import Aboutus from "./Components/about page/Aboutus";
import ProductPage from "./Components/Product page/ProductPage";
import Cart from "./Components/Cart page/Cart";
import Contact from "./Components/contact page/contactus";
import Products from "./Components/products page/products";
import Checkout from "./Components/Checkout/checkout";
import SignUp from "./Components/Login/SignUp";
import Signin from "./Components/Login/Signin";
import Congrats from "./Components/Login/Congrats";
import { AuthContextProvider } from "./Components/authcontext/Authcontext";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import { commerce } from "./Components/lib/commerce";
const ResultContext = createContext();
function App({ children }) {
  const [products, setProduct] = useState([]);
  const [cart, setCart] = useState({});
  const [order, setorder] = useState({});
  const [errorms, seterrorms] = useState("");

  async function fetchProduct() {
    const { data } = await commerce.products.list();
    setProduct(data);
  }

  async function fetchCart() {
    const cart = await commerce.cart.retrieve();
    setCart(cart);
  }

  async function handleAddToCart(productId, quantity) {
    const response = await commerce.cart.add(productId, quantity);
    setCart(response.cart);
  }

  async function handleUpdateCartQty(productId, quantity) {
    const response = await commerce.cart.update(productId, { quantity });
    setCart(response.cart);
  }
  async function handleRemoveFromCart(productId) {
    const response = await commerce.cart.remove(productId);
    setCart(response.cart);
  }
  async function HandleEmptyCard() {
    const response = await commerce.cart.empty();
    setCart(response.cart);
  }
  async function refleshCart() {
    const newCart = await commerce.cart.refresh();
    setCart(newCart);
  }
  async function handleCaptureCHeckout(checkoutTokenId, newOrder) {
    try {
      const incomingOrder = await commerce.checkout.capture(
        checkoutTokenId,
        newOrder
      );
      setorder(incomingOrder);
      refleshCart();
    } catch (error) {
      seterrorms(error.data.error.message);
    }
  }
  useEffect(() => {
    fetchProduct();
    fetchCart();
  }, []);
  // ScrollToTop function
  function ScrollToTop() {
    const { pathname } = useLocation();

    React.useEffect(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, [pathname]);

    return null;
  }
  const [active, setactive] = useState(0);

  return (
    <>
      <ResultContext.Provider value={{ setactive, active }}>
        {children}
        <AuthContextProvider>
          <Router>
            <ScrollToTop />
            <div className="">
              <div className="wrapper font-font wrappertablet wrapperphone">
                <Routes>
                  <Route
                    path="/"
                    element={[
                      <Nav totalItems={cart.total_items} />,
                      <Hero />,
                      <Projects
                        cart={cart}
                        handleUpdateCartQty={handleUpdateCartQty}
                        handleRemoveFromCart={handleRemoveFromCart}
                        HandleEmptyCard={HandleEmptyCard}
                        products={products}
                        onAddToCart={handleAddToCart}
                        // ProductView={ProductView}
                      />,
                      <About />,
                      <Parteners />,
                      <Testimonials />,
                      <Footer />,
                      <Footer1 />,
                    ]}
                  />
                  <Route
                    path="/about-us"
                    element={[
                      <Nav totalItems={cart.total_items} />,
                      <Aboutus />,
                      <Footer />,
                      <Footer1 />,
                    ]}
                  />
                  <Route
                    path="/cart"
                    element={[
                      <Nav totalItems={cart.total_items} />,
                      <Cart
                        cart={cart}
                        handleUpdateCartQty={handleUpdateCartQty}
                        handleRemoveFromCart={handleRemoveFromCart}
                        HandleEmptyCard={HandleEmptyCard}
                      />,
                      <Footer />,
                      <Footer1 />,
                    ]}
                  />
                  <Route
                    path="/Product-page/:id"
                    element={[
                      <Nav totalItems={cart.total_items} />,
                      <ProductPage
                        products={products}
                        handleUpdateCartQty={handleUpdateCartQty}
                        onAddToCart={handleAddToCart}
                      />,
                      <Footer />,
                      <Footer1 />,
                    ]}
                  />
                  <Route
                    path="/Contact"
                    element={[
                      <Nav totalItems={cart.total_items} />,
                      <Contact />,
                      <Footer />,
                      <Footer1 />,
                    ]}
                  />
                  <Route
                    path="/Products"
                    element={[
                      <Nav totalItems={cart.total_items} />,
                      <Products
                        cart={cart}
                        handleUpdateCartQty={handleUpdateCartQty}
                        handleRemoveFromCart={handleRemoveFromCart}
                        HandleEmptyCard={HandleEmptyCard}
                        products={products}
                        onAddToCart={handleAddToCart}
                      />,
                      <Footer />,
                      <Footer1 />,
                    ]}
                  />
                  <Route
                    path="/checkout"
                    element={[
                      <Nav totalItems={cart.total_items} />,
                      <Checkout
                        cart={cart}
                        order={order}
                        errorms={errorms}
                        handleCaptureCHeckout={handleCaptureCHeckout}
                      />,
                    ]}
                  />
                </Routes>
              </div>
              <div className="font-font">
                <Routes>
                  <Route path="/SignUp" element={[<SignUp />]} />
                  <Route path="/Signin" element={[<Signin />]} />
                  <Route path="/Congrats" element={[<Congrats />]} />
                </Routes>
              </div>
            </div>
          </Router>
        </AuthContextProvider>
      </ResultContext.Provider>
    </>
  );
}

export default App;
export const useResultContext = () => useContext(ResultContext);
